import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	to: {
		id: 'jql-builder-basic-datetime.in-range-of-time.to',
		defaultMessage: 'to',
		description: 'Text to connect timestring from and timestring to in a date inerval',
	},
	startTimeRangeLabel: {
		id: 'jql-builder-basic-datetime.in-range-of-time.start-time-range-label',
		defaultMessage: 'Enter start of the time range e.g weeks, days, hours and/or minutes',
		description: 'Label for start time range',
	},
	endTimeRangeLabel: {
		id: 'jql-builder-basic-datetime.in-range-of-time.end-time-range-label',
		defaultMessage: 'Enter end of the time range',
		description: 'Label for end time range',
	},
});
